import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '../../lib/cn.js';
const widths = {
    reading: 'max-w-measure-max',
    focused: 'max-w-page-focused',
    operational: 'max-w-page-operational',
    wide: 'max-w-container-max',
};
/**
 * Owns page measure and section rhythm, never a surface or another main landmark.
 * The application shell owns gutters, navigation clearance and scrolling.
 * Width is explicit so each route selects a composition rather than a device size.
 */
export function PageLayout({ width, className, ...props }) {
    return (_jsx("div", { ...props, className: cn('mx-auto flex w-full min-w-0 flex-col gap-6 md:gap-8', widths[width], className) }));
}
//# sourceMappingURL=PageLayout.js.map